import React from "react";
import "../CoreValues.css";

import {
  FaLightbulb,
  FaHandshake,
  FaUsers,
  FaAward,
  FaShieldAlt,
  FaSyncAlt,
} from "react-icons/fa";

const values = [
  {
    icon: <FaLightbulb />,
    title: "Innovation",
    description:
      "We embrace creativity and emerging technologies to build innovative digital solutions that create lasting business value.",
  },
  {
    icon: <FaHandshake />,
    title: "Integrity",
    description:
      "Honesty, transparency, and accountability form the foundation of every relationship we build with our clients and partners.",
  },
  {
    icon: <FaUsers />,
    title: "Customer First",
    description:
      "Our clients are at the heart of everything we do. Their success is our greatest achievement and strongest motivation.",
  },
  {
    icon: <FaAward />,
    title: "Excellence",
    description:
      "We are committed to delivering high-quality software solutions through engineering excellence and continuous improvement.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Trust & Security",
    description:
      "We prioritize security, reliability, and confidentiality while developing scalable technology solutions for businesses.",
  },
  {
    icon: <FaSyncAlt />,
    title: "Continuous Growth",
    description:
      "Technology evolves rapidly, and so do we. Learning, adapting, and improving are part of our everyday culture.",
  },
];

const CoreValues = () => {
  return (
    <section className="core-values">

      <div className="company-container">

        <span className="section-tag">
          CORE VALUES
        </span>

        <h2>
          The Principles That
          <span> Define VisionVote</span>
        </h2>

        <p className="values-intro">
          Our values shape our culture, guide every decision, and inspire us to
          deliver innovative technology solutions that empower businesses,
          strengthen partnerships, and create meaningful digital experiences.
        </p>

        <div className="values-grid">

          {values.map((value, index) => (

            <div className="value-card" key={index}>

              <div className="value-icon">
                {value.icon}
              </div>

              <h3>{value.title}</h3>

              <p>{value.description}</p>

            </div>

          ))}

        </div>

      </div>

    </section>
  );
};

export default CoreValues;